import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { getToken, fetchMe, clearToken } from "@/api";
import Login from "@/components/Login";
import VerifyPage from "@/components/VerifyPage";
import CycleGate from "@/components/CycleGate";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    if (!getToken()) { setLoading(false); return; }
    try {
      const me = await fetchMe();
      setUser(me);
    } catch (e) {
      clearToken();
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const onAuthed = useCallback((u) => { setUser(u); setLoading(false); }, []);

  if (loading) {
    return (
      <div className="auth-loading" data-testid="app-loading">
        <div className="gen-dots"><span /><span /><span /></div>
        Loading your Findability Cycle…
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/auth/verify" element={<VerifyPage onAuthed={onAuthed} />} />
          <Route
            path="/"
            element={user ? <CycleGate user={user} setUser={setUser} /> : <Login />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
